import React, { useState } from 'react';
import omit from 'lodash/omit';
import startCase from 'lodash/startCase';
import shortid from 'shortid';
import {
  ErrorMessage,
  useFormikContext,
} from 'formik';

import FormField from './FormField.jsx';
import FormRadioField from './FormRadioField.jsx';

const FormGroup = (props) => {
  const {
    label,
    name,
    radio,
    required = false,
    helpText,
  } = props;
  const { status } = useFormikContext();
  const [id] = useState(() => `a${shortid.generate()}`);
  const p = {
    id,
    ...omit(props, ['label', 'required', 'helpText']),
    ...status
  };

  return (
    <div className="form-group">
      {label !== null && (
        <label htmlFor={id}>
          {label || startCase(name)}
          {required ? ' *' : ''}
        </label>
      )}
      {radio ? (
        <FormRadioField {...p} />
      ) : (
        <FormField {...p} />
      )}
      {helpText && (
        <small className="form-text text-muted">
          {helpText}
        </small>
      )}
      <ErrorMessage name={name}>
        {(msg) => (
          <div className="invalid-feedback">{msg}</div>
        )}
      </ErrorMessage>
    </div>
  );
};

export default FormGroup;
